export default __webpack_public_path__ + "static/media/boy-default-512x512.01505af6.png";